import { Component } from "react";
import { toast, ToastContainer } from "react-toastify";

import LoadingIndicator from "../Common/components/LoadingIndicator";

import { getUserId } from "../../utils/CommonFunction";
import { locQRLocationData } from "../../utils/apiRoutes";
import { getHeaders } from "../../utils/apiHelper";
import QRCode from "react-qr-code";

export default class LocQR extends Component {
  constructor() {
    super();
    this.state = {
      user_id: getUserId("user_info"),
      lat: null,
      long: null,
      branchInfo: null,
      locationToken: null,
      loading: true,
      error: null,
    };
  }

  fetchLocationData = async (latitude, longitude) => {
    const route =
      locQRLocationData + `/latitude/${latitude}/longitude/${longitude}`;
    const res = await fetch(route, {
      headers: getHeaders(false),
    });
    if (!res.ok) {
      return toast.error(
        "Something went wrong. Unable to get location data from the server."
      );
    }
    const { data } = await res.json();
    this.setState({
      loading: false,
      branchInfo: data.attendanceBranch,
      locationToken: data.locationToken,
    });
  };

  getLocation = () => {
    if (!("geolocation" in navigator)) {
      this.setState({
        error: "Geolocation is not supported by this browser.",
      });
      return;
    }
    this.setState({ loading: true, error: null });
    const options = {
      enableHighAccuracy: true, // better accuracy; more battery
      timeout: 5000, // fail fast if slow
      maximumAge: 0, // don’t use cached location
    };
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        this.setState({
          lat: pos.coords.latitude.toFixed(7),
          long: pos.coords.longitude.toFixed(7),
          error: null,
        });
        this.fetchLocationData(
          pos.coords.latitude.toFixed(7),
          pos.coords.longitude.toFixed(7)
        );
      },
      (err) => {
        this.setState({
          lat: null,
          long: null,
          loading: false,
          error: err.message,
        });
      },
      options
    );
  };

  componentDidMount() {
    this.getLocation();
  }

  render() {
    const hasFetchedLocData = !!this.state.branchInfo?.branchId;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "35px 0px",
          backgroundColor: "#f3f3f4",
        }}
      >
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        {this.state.loading && (
          <div style={{ marginTop: 50 }}>
            <LoadingIndicator backgroundColor="FFFFFF" />
          </div>
        )}
        {!this.state.loading && (
          <div
            className="col-lg-7 col-md-10 col-sm-12"
            style={{ backgroundColor: "#ffff" }}
          >
            <h2 style={{ textAlign: "center" }}>Location QR</h2>
            {this.state.branchInfo && (
              <div
                style={{
                  textAlign: "center",
                  color: hasFetchedLocData ? "green" : "red",
                  fontWeight: "bold",
                  marginTop: 20,
                }}
              >
                {this.state.branchInfo.branchName}
              </div>
            )}
            {hasFetchedLocData && (
              <div style={{ marginTop: 20, textAlign: "center" }}>
                <QRCode value={this.state.locationToken} />
              </div>
            )}
            <div
              style={{ marginTop: 20, marginBottom: 20, textAlign: "center" }}
            >
              <button
                onClick={this.getLocation.bind(this)}
                style={{
                  height: 35,
                  backgroundColor: "#1872ab",
                  border: "none",
                  color: "#fff",
                  borderRadius: 5,
                }}
              >
                {hasFetchedLocData ? (
                  "Refresh Location"
                ) : (
                  <>
                    <i class="fa fa-street-view" aria-hidden="true"></i> Get QR
                    Code
                  </>
                )}
              </button>
            </div>

            {this.state.error && (
              <>
                <p style={{ color: "red", textAlign: "center" }}>
                  Error: {this.state.error}
                </p>
                <p style={{ color: "#9A9A9A", textAlign: "center" }}>
                  Please allow location access to continue.
                </p>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}
